export const channelTypeOptions = [
  {
    label: "无通道",
    value: 0
  },
  {
    label: "仅主通道",
    value: 1
  },
  {
    label: "主通道 & 子通道",
    value: 2
  }
];

export const liveStreamingStatusOptions = [
  {
    title: "直播状态",
    value: ""
  },
  {
    title: "待开始",
    value: "0"
  },
  {
    title: "进行中",
    value: "1"
  },
  {
    title: "已结束",
    value: "2"
  }
];

// 针对督学中心的：
// 直播状态：
export const liveStatusOptions = [
  {
      name: "异常",
      value: -1
  },
  {
      name: "异常",
      value: -2
  },
  {
      name: "不存在",
      value: -3
  },
  {
      name: "未开始",
      value: 0
  },
  {
      name: "录制中",
      value: 1
  },
  {
      name: "已结束",
      value: 2
  }
];

// 针对不同直播状态的提示信息：
export const hintByliveStatusOptions = [
  {
      name: "课堂异常，请刷新重试",
      value: -1
  },
  {
      name: "课堂异常，请刷新重试",
      value: -2
  },
  {
      name: "课堂不存在，请核对链接是否正确",
      value: -3
  },
  {
      name: "课堂还未开始，请稍后再来",
      value: 0
  },
  {
      name: "直播中",
      value: 1
  },
  {
      name: "您来晚了，课堂已结束~",
      value: 2
  }
];